import React from 'react';
import { BaseInputProps, SmartTagsTextInputWithLoad } from 'ui-builder';
import { TaskType, useSmartTagsService } from 'nekst-api';

interface EmailPlanTaskTitleInputProps extends BaseInputProps {
  planId: number,
}

export function EmailPlanTaskTitleInput(props: EmailPlanTaskTitleInputProps) {
  const smartTagsService = useSmartTagsService();

  return (
    <SmartTagsTextInputWithLoad
      getTagsMethod={async () => {
        return smartTagsService.getSmartTagsByPlanId(props.planId, TaskType.EMAIL);
      }}
      dependencies={[props.planId]}
      label={props.label}
      source="name"
    />
  );
}
